import { checkCollection, addCollection, removeCollection, getCollectionCounts, getCollectionList } from '@/axios/api/favorite.js'

const state = {
  activeTab: {}
}
const getters = {
  activeTab: state => state.activeTab
}
const UPDATE_ACTIVE_TAB = 'UPDATE_ACTIVE_TAB'
const mutations = {
  [UPDATE_ACTIVE_TAB] (state, activeTab) {
    state.activeTab = activeTab
  }
}
const actions = {
  async checkCollectionApi ({ commit }, params) {
    try {
      let { data: res } = await checkCollection(params)
      return res
    } catch (e) {}
  },
  async addCollectionApi ({ commit }, params) {
    try {
      let res = await addCollection(params)
      return res
    } catch (e) {}
  },
  async removeCollectionApi ({ commit }, params) {
    try {
      let res = await removeCollection(params)
      return res
    } catch (e) {}
  },
  async getCollectionCountsApi ({ commit }, params) {
    try {
      let { data: res } = await getCollectionCounts(params)
      return res
    } catch (e) {}
  },
  async getCollectionListApi ({ commit }, params) {
    try {
      let { data: res } = await getCollectionList(params)
      return res
    } catch (e) {}
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/favorite.js